import {Component, Inject, OnInit, Optional} from '@angular/core';
import {IOneToOneTopics} from 'src/app/interfaces/hr-data.interface';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {
  columnTypes,
  UITableHeader,
} from 'src/app/shared/ui-kits/table/table.models';

@Component({
  selector: 'app-topics',
  templateUrl: './topics.component.html',
  styleUrls: ['./topics.component.scss'],
})
export class TopicsComponent implements OnInit {
  public columnTypes!: columnTypes;
  public dataTopics: IOneToOneTopics[] = [];
  public headersTopics: UITableHeader[] = [
    {key: 'topic', index: 0, type: columnTypes.dropDown},
    {key: 'satisfactionLevel', index: 1, type: columnTypes.dropDown},
    {key: 'importanceLevel', index: 2, type: columnTypes.dropDown},
    {key: 'status', index: 3, type: columnTypes.dropDown},
    {key: 'comment', index: 4},
    {key: 'id', index: 5, notVisible: true},
    {key: 'oneToOneId', index: 6, notVisible: true},
  ];

  constructor(
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IOneToOneTopics[]
  ) {}

  ngOnInit() {
    this.dataTopics = this.data;
  }

  closeModal() {
    this.dialogRef.close();
  }
}
